export default /*@ngInject*/ function ($http, errorsDataService) {

    const service = {
        getProfiles,
        getSensitiveProfiles,
        exportProfiles,
        updateProfiles,
        importProfiles,
        deleteProfile
    };

    return service;

    async function getProfiles() {
        try {
            return await $http.get(`${apiUrl}api/assure/sap/profilemaster`);
        } catch (err) {
            showError(err);
        }
    }

    async function getSensitiveProfiles() {
        try {
            return await $http.get(`${apiUrl}api/assure/sap/sensitiveprofile/`);
        } catch (err) {
            showError(err);
        }
    }

    async function exportProfiles() {
        try {
            return await $http.get(`${apiUrl}api/assure/sap/sensitiveprofile/export`, { responseType: "blob" });
        } catch (err) {
            showError(err);
        }
    }

    async function updateProfiles(postData) {
        try {
            return await $http.post(`${apiUrl}api/assure/sap/sensitiveprofile/`, postData);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function importProfiles(fd) {
        try {
            return await $http.put(`${apiUrl}api/assure/sap/sensitiveprofile/import`, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function deleteProfile(id) {
        try {
            return await $http.delete(`${apiUrl}api/assure/sap/sensitiveprofile/${id}`);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    function sendError(err) {
        throw err;
    }

    function showError(err) {
        errorsDataService.catch(err);
    }
}